import * as React from 'react';

import { TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const FinishDateContainer: React.FC = () => {
  const { published, newbuildingHouse } = useOfferContext();
  const finishDate = newbuildingHouse && newbuildingHouse.finishDate;

  return <TextField published={published}>{finishDate}</TextField>;
};
